module.exports = __webpack_public_path__ + "img/maotouy.19b13f73.png";